import Vue from 'vue'
import {
  DatePicker,
  Table,
  TableColumn,
  Loading
} from 'element-ui'
Vue.use(DatePicker)
Vue.component('el-table', Table);
Vue.component('el-table-column', TableColumn);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
